/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * Canned data so the UI can be built and design-reviewed with no backend.
 * Used only when USE_MOCK is flipped on in assistantClient.js.
 */

/** Domain-correct starter prompts for the empty state (developer platform). */
export const SUGGESTED_PROMPTS = [
  "How do I register a new device?",
  "Summarise the health of my active devices",
  "Show me how to create an API key",
  "What can the AI Agents service do?",
];

/**
 * A scripted assistant reply used by the mock streamer.
 * @param {string} userMessage
 * @returns {import("./types").StreamEvent[]}
 */
export const scriptReply = (userMessage) => {
  const chunks = [
    "Here's a quick overview.\n\n",
    "You can **register a device** from the Devices page — ",
    "generate an install command, run it on the device, and it registers automatically.\n\n",
    "Want me to open the Devices page for you?",
  ];
  return [
    { type: "step", label: "Checked developer docs", status: "done" },
    ...chunks.map((text) => ({ type: "token", text })),
    { type: "title", title: "Getting started with devices" },
    { type: "done" },
  ];
};
